
export default class {
    static minPrice = 0;
    static maxPrice = 3000;
}